import { render, staticRenderFns } from "./CreatePartner.vue?vue&type=template&id=49cc6681&scoped=true&"
import script from "./CreatePartner.vue?vue&type=script&lang=js&"
export * from "./CreatePartner.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49cc6681",
  null
  
)

export default component.exports